/** The drawings HelperFunctions' photo URLs return when a listing has no photo of its own. */
const STAND_IN_PHOTO = /\/img\/(motorhome|caravan)[\w-]*\.svg$/;

/** True for a missing photo or one of those stand-in drawings: show a "no photos yet" state instead. */
export function isStandInPhoto(url: string | null | undefined): boolean {
  return !url || STAND_IN_PHOTO.test(url);
}
